import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector, useShareFile } from '../../hooks'
import FilePermissions from './FilePermissions'
import { App } from '../../app/root'
import { Option } from './FilePermissions'
import { closeDialog, selectDialogProps, setDialog } from '../../app/dialog'
import {
  MappedFileTypes,
  StaticFileIconsConstant,
  googlePermissionsOptions,
  valueToVerb,
} from '../../constants'
import { useCreateFileGoogleMutation } from '../../app/appApiQueries'
import { zoomSdkApi } from '../../app/zoomSdkQueries'
import { generateZoomCollabFilename } from '../../helpers'

const FileShareDialogGoogleNew = () => {
  const dispatch = useDispatch()
  const { screenName } = zoomSdkApi.endpoints.getUserContext.useQueryState(
    'getUserContext',
    {
      selectFromResult: (result) => ({
        screenName: result?.data?.screenName,
      }),
    }
  )
  const setShareFile = useShareFile()
  const [createFileGoogle] = useCreateFileGoogleMutation()
  const dialogProps = useAppSelector(selectDialogProps)
  const [permission, setPermission] = useState<Option['value']>('editor')
  const iconType = dialogProps?.file || 'docx'
  const fileName = generateZoomCollabFilename()
  const Icon = StaticFileIconsConstant['Google'][iconType]

  const onClose = () => {
    dispatch(closeDialog())
  }

  const handleGrant = async () => {
    if (screenName) {
      // we are a new file
      const data = await createFileGoogle({
        fileName,
        fileType: MappedFileTypes[iconType],
        share: true,
      }).unwrap()

      const shareFileData = {
        ...data,
        drive: 'Google' as App,
        accessType: permission,
        screenName,
      }

      await zoomSdk
        .zmSystemBrowserCollaboration({
          fileUrl: shareFileData.fileUrl,
          messageText: `Upon joining, the email associated with your Google account will be granted ${valueToVerb(permission)} access`,
        })
        .then(() => {
          setShareFile(shareFileData)
          zoomSdk.sendAppToBackground() // we don't want to see the app
        })
        .catch((e) => {
          if (
            e?.message === 'The app is in collaborate mode.' ||
            e?.message === 'No Permission for this API.'
          ) {
            dispatch(
              setDialog({
                type: 'collaborationInProgressNew',
                props: { file: iconType, fileUrl: data?.fileUrl },
              })
            )
          } else {
            dispatch(closeDialog())
          }
        })
    }
  }

  return (
    <FilePermissions
      options={googlePermissionsOptions}
      onChange={setPermission}
      handleGrant={handleGrant}
      onClose={onClose}
      fileName={fileName!}
      icon={Icon}
      app={'Google'}
    />
  )
}

export default FileShareDialogGoogleNew
